import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import { selectOrganization } from "../organization-slice";
import {
  buildVocabularyVariables,
  VocabularyVariables,
} from "../utils/vocabularyVariables";

/**
 * The organization's words for the active UI language: `member`, `members`,
 * `Member`, `Members` and the same four forms for every other slot. The
 * Default preset applies until the organization has loaded.
 */
export const useVocabulary = (): VocabularyVariables => {
  const { i18n } = useTranslation();
  const vocabulary = useAppSelector(selectOrganization)?.vocabulary ?? null;
  const language = i18n.language;
  return useMemo(() => buildVocabularyVariables(vocabulary, language), [vocabulary, language]);
};
